require('./ctxPercentageBar.style.scss');

const containerPadding = 10;
const spanHeight = 12; //height of span (for labels) depends on font-size

class CtxPercentageBarController {
    constructor($scope, $element, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.$timeout(() => {
            this.width = this.$element.find(".svg-graph").width();
            this.height = this.$element.find(".svg-graph").height();
            this.draw();
            this.setWatch('height');
            this.setWatch('width');
            this.tooltip = this.createTooltip();
        });
    }

    setWatch(dimension) {
        this.$scope.$watch(() => this.$element.find(".svg-graph")[dimension](), value => {
            if (this[dimension] !== value) {
                this[dimension] = value;
                this.draw(true);
            }
        });
    }

    draw(reDraw) {
        if (reDraw) this.$element.find(".svg-graph").empty();
        this.placeholder = this.$element.find('.svg-graph')[0];
        this.leftLabelContainer = d3.select(this.$element.find('.left-labels')[0]);
        let radiusDifference = parseInt(this.radiusDifference),
            data = this.calculatePercentage(this.data),
            label = data + '%',
            showCircle = this.width >= this.height,
            width = showCircle ? this.height : this.width / 2,
            height = this.height,
            radiusY = height / 2,
            radiusX = width / 2,
            maxBarHeight = radiusY * 2,
            percentageTextSize = showCircle ? 26 : 16,
            percentageTextDiffSize = showCircle ? 18.2 : 11.2,
            textWidth,
            textHeight,
            svg,
            y,
            yAxisRight,
            yAxisLeft;

        if (!reDraw) {
            this.addGrid();
            this.addRightLabels();
            this.addLeftLabels();
        }

        this.y = d3.scale.linear()
            .range([maxBarHeight, 0])
            .domain([0, 100]);

        svg = d3.select(this.placeholder)
            .append('svg')
            .attr('height', height)
            .attr('width', width)
            .attr('viewBox', `0, 0, ${width}, ${height}`)
            .attr('preserveAspectRatio', 'none meet');

        svg.append('defs')
            .append("clipPath")
            .attr("id", 'clipPathCustomFrame');

        let customFrame = svg.select("#clipPathCustomFrame");
        if (showCircle) {
            customFrame.append("ellipse")
                .attr("cx", width / 2)
                .attr("cy", height / 2)
                .attr("rx", radiusX - radiusDifference > 0 ? radiusX - radiusDifference : 0)
                .attr("ry", radiusY - radiusDifference > 0 ? radiusY - radiusDifference : 0);

            svg.append("ellipse")
                .attr("id", "ellipse_uuid")
                .attr("class", "outer-circle")
                .attr("cx", width / 2)
                .attr("cy", height / 2)
                .attr("rx", radiusX)
                .attr("ry", radiusY);
        } else {
            customFrame.append("rect")
                .attr('height', height - 2 * radiusDifference)
                .attr('width', width - 2 * radiusDifference)
                .attr('x', radiusDifference)
                .attr('y', radiusDifference);

            svg.append('rect')
                .attr("id", "rect_uuid")
                .attr("class", "outer-circle")
                .attr('height', height)
                .attr('width', width);
        }

        this.rect = svg.append("g")
            .append("rect")
            .style("clip-path", "url(#clipPathCustomFrame)")
            .attr("fill", this.barColor)
            .attr("y", this.y(data))
            .attr("x", width / 2 - radiusX)
            .attr("width", radiusX * 2)
            .attr("height", maxBarHeight - this.y(data));

        this.text = d3.select(this.placeholder)
            .append("div")
            .attr("class", "percentage-label-container")
            .style("width", () => {
                textWidth = width < height ? "80" : 100 * (height * 0.8) / width;
                return '100' + "%";
            })
            .style("height", () => {
                textHeight = height < width ? "80" : 100 * (width * 0.8) / height;
                return height - radiusDifference * 2 + "px";
            })
            .style("left", "0")
            .style("top", containerPadding + radiusDifference + 'px');
        this.text
            .append("span")
            .attr("class", "percentage-label percentage-label-empty-color")
            .style('font-size', () => {
                return percentageTextSize + 'px';
            })
            .style("margin-top", () => height / 2 - radiusDifference - percentageTextDiffSize + 'px')
            .attr("title", label)
            .html(label);

        d3.select(this.placeholder)
            .append("div")
            .attr("class", "percentage-label-container")
            .style("width", () => {
                textWidth = width < height ? "80" : 100 * (height * 0.8) / width;
                return '100' + "%";
            })
            .style("height", () => {
                textHeight = height < width ? "80" : 100 * (width * 0.8) / height;
                return height - radiusDifference * 2 + "px";
            })
            .style("left", "0")
            .style("top", containerPadding + radiusDifference + 'px')
            .append("span")
            .attr("class", "percentage-label percentage-label-full-color")
            .style('font-size', () => {
                return percentageTextSize + 'px';
            })
            .style("margin-top", () => height / 2 - radiusDifference - percentageTextDiffSize + 'px')
            .attr("title", label)
            .html(label);

        this.$scope.$watch(() => this.data, () => {
            this.change(this.calculatePercentage(this.data));
        });
        this.$scope.$watch(() => this.max, () => {
            this.addLeftLabels();
        });
    }

    change(data) {
        let label = data + '%';
        let radiusDifference = parseInt(this.radiusDifference),
            radiusY = this.height / 2,
            maxBarHeight = radiusY * 2,
            height = this.height;
        this.rect.transition().duration(500)
            .attr("y", this.y(data))
            .attr("height", maxBarHeight - this.y(data));

        this.text.transition().duration(500)
            .style("height", () => ((100 - data) * (height - radiusDifference * 2)) / 100 + 'px');

        d3.select(this.placeholder).selectAll(".percentage-label").attr("title", label)
            .html(label);
    }

    calculatePercentage(data) {
        return this.max === '0' ? 0 : Math.round(data * 100 / this.max);
    }

    addLeftLabels() {
        let that = this,
            radiusDifference = parseInt(this.radiusDifference);
        this.leftLabelContainer.selectAll("span").remove();
        this.leftLabelContainer
            .style("padding-top", `${radiusDifference + containerPadding - spanHeight}px`)
            .style("padding-bottom", `${radiusDifference + containerPadding}px`);

        for (let i = 0; i < this.tickNumber; i++) {
            let className = (i ? '' : 'first-') + (i === this.tickNumber - 1 ? 'last-' : '') + 'line grid-label',
                tooltipLabel = Math.round((parseInt(this.max) / (this.tickNumber - 1)) * (this.tickNumber - 1 - i)) + ` ${this.labelUnit}`,
                id = 'left-grid-label-' + i;
            this.leftLabelContainer
                .append("span")
                .attr("class", className)
                .append("span")
                .attr("id", id)
                .html(tooltipLabel)
                .on("mouseover", () => {
                    let el = $('#' + id), tooltipEl;
                    that.tooltip.style("display", "none");
                    if (!this.isEllipsisActive(el[0])) return;
                    that.tooltip.html(tooltipLabel);
                    tooltipEl = $(that.tooltip[0]);
                    this.$timeout(() => {
                        that.tooltip.style("top", el[0].offsetTop - tooltipEl.outerHeight() - 8 + 'px');
                        that.tooltip.style("left", el[0].offsetLeft + el[0].parentNode.offsetWidth / 2 - tooltipEl.outerWidth() / 2 + 'px');
                        that.tooltip.style("display", null);
                    });
                })
                .on("mouseout", function () {
                    that.tooltip.style("display", "none");
                });
        }
    }

    addRightLabels() {
        let that = this,
            radiusDifference = parseInt(this.radiusDifference);
        let rightLabelContainer = d3.select(this.$element.find('.right-labels')[0])
            .style("padding-top", `${radiusDifference + containerPadding - spanHeight}px`)
            .style("padding-bottom", `${radiusDifference + containerPadding}px`);

        for (let i = 0; i < this.tickNumber; i++) {
            let className = (i ? '' : 'first-') + (i === this.tickNumber - 1 ? 'last-' : '') + 'line grid-label',
                tooltipLabel = Math.round((100 / (this.tickNumber - 1)) * (this.tickNumber - 1 - i)) + '%',
                id = 'right-grid-label-' + i;
            rightLabelContainer
                .append("span")
                .attr("class", className)
                .append("span")
                .attr("id", id)
                .html(tooltipLabel)
                .on("mouseover", () => {
                    let el = $('#' + id), tooltipEl;
                    that.tooltip.style("display", "none");
                    if (!this.isEllipsisActive(el[0])) return;
                    that.tooltip.html(tooltipLabel);
                    tooltipEl = $(that.tooltip[0]);
                    this.$timeout(() => {
                        that.tooltip.style("top", el[0].offsetTop - tooltipEl.outerHeight() - 8 + 'px');
                        that.tooltip.style("left", el[0].offsetLeft + el[0].parentNode.offsetWidth / 2 - tooltipEl.outerWidth() / 2 + 'px');
                        that.tooltip.style("display", null);
                    });
                })
                .on("mouseout", function () {
                    that.tooltip.style("display", "none");
                });
        }
    }

    addGrid() {
        let radiusDifference = parseInt(this.radiusDifference);
        let gridContainer = d3.select(this.$element.find('.grid-container')[0])
            .style("padding", `${radiusDifference + containerPadding}px 0`);

        for (let i = 0; i < this.tickNumber; i++) {
            let className = (i ? '' : 'first-') + (i === this.tickNumber - 1 ? 'last-' : '') + 'line grid-line';
            gridContainer
                .append("div")
                .attr("class", className);
        }
    }

    createTooltip() {
        let placeholder = this.$element.find(".ctx-percentage-bar-content")[0];
        return d3.select(placeholder)
            .append('div')
            .attr('class', 'bar-content-tooltip')
            .style("display", "none");

    }

    isEllipsisActive(e) {
        return (e.offsetWidth > e.parentNode.offsetWidth);
    }
}

const ctxPercentageBarComponent = {
    restrict: 'E',
    controller: CtxPercentageBarController,
    scope: {},
    template: require('./ctxPercentageBar.template.html'),
    bindings: {
        data: '<',
        max: '@',
        tickNumber: '@',
        labelUnit: '@',
        barColor: '@',
        radiusDifference: '@'
    }
};

CtxPercentageBarController.$inject = ['$scope', '$element', '$timeout'];

module.exports = ctxPercentageBarComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxPercentageBar/ctxPercentageBar.component.js